import {
  signInWithPopup,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, provider } from "../firebase"; // Zorg dat provider Google is
import { useState, useEffect } from "react";
import "./login.css";

// Alleen deze e-mails mogen inloggen
const ALLOWED_EMAILS = [
  "henkjanzweers@zuidzorg.nl",
  "susandegroot@zuidzorg.nl",
  "philverhallen@zuidzorg.nl",
  "tegeltester@zuidzorg.nl",
  "robertgreiving@zuidzorg.nl"
];

const Login = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [checkingAuth, setCheckingAuth] = useState(true);

  // 🔄 Automatische redirect als al ingelogd
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user && ALLOWED_EMAILS.includes(user.email)) {
        navigate("/berichten");
      }
      setCheckingAuth(false);
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleLogin = async () => {
    setError("");

    try {
      await setPersistence(auth, browserSessionPersistence);
      const result = await signInWithPopup(auth, provider);
      const email = result.user.email;

      if (!ALLOWED_EMAILS.includes(email)) {
        setError("Je hebt geen toegang tot deze pagina.");
        await auth.signOut();
        return;
      }

      navigate("/berichten");
    } catch (err) {
      console.error("Login error:", err);
      setError("Inloggen mislukt. Probeer het opnieuw.");
    }
  };

  if (checkingAuth) return null; // Wacht tot auth check klaar is

  return (
    <div className="login-container">
      <h2 className="pagename">Inloggen met Google</h2>
      <div className="loginbutton">
        <button className="login-button" onClick={handleLogin}>
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google logo"
            className="google-icon"
          />
          Inloggen met Google
        </button>
      </div>
      {error && <p className="error-message show">{error}</p>}
    </div>
  );
};

export default Login;
